export const labelWidth = 30;
export const minPoolHeight = 200;
export const minPoolWidth = 300;
export const poolPadding = 20;
export const labelHeight = 30;
